import { SkeletonProfileImage } from '@xing-com/skeleton';

import { Styled } from './styles';

const ArticleAuthorFollowerEntrySkeleton: React.FC = () => {
  return (
    <Styled.AuthorFollowersEntryContainerSkeleton>
      <SkeletonProfileImage />

      <Styled.AuthorFollowersEntryInfoSkeleton amountRows={3} />
    </Styled.AuthorFollowersEntryContainerSkeleton>
  );
};

const ArticleAuthorFollowersSkeleton: React.FC = () => {
  const fakeArray = new Array(3).fill(0);

  return (
    <Styled.AuthorFollowersSkeleton>
      <Styled.AuthorFollowersHeadlineSkeleton amountRows={1} />

      {fakeArray.map((_, index) => (
        <ArticleAuthorFollowerEntrySkeleton key={index} />
      ))}
    </Styled.AuthorFollowersSkeleton>
  );
};

export default ArticleAuthorFollowersSkeleton;
